import { Anchor, TextItem, Modal, withAnalytics } from '@lux/components-gomo';
import GomoTabs from './Tabs';
import { Button as dlsButton } from '@dls/web';

const ButtonWithAnalytics = withAnalytics(dlsButton, {
  onClick: 'click'
});

const TabsWithAnalytics = withAnalytics(GomoTabs, {
  onChange: 'change'
});

const AnchorWithAnalytics = withAnalytics(Anchor, {
  onClick: 'click'
});

const TextItemWithAnalytics = withAnalytics(TextItem, {
  onClick: 'click'
});

const ModalWithAnalytics = withAnalytics(Modal, {
  onModalClose: 'modalClose',
  onModalRender: 'modalRender'
});

export { ButtonWithAnalytics as Button };
export { TabsWithAnalytics as Tabs };
export { AnchorWithAnalytics as Anchor };
export { TextItemWithAnalytics as TextItem };
export { ModalWithAnalytics as Modal };
